import { AccountsEntityCountStateInterface } from '../../models';

export const accountsEntityCountInitialState: AccountsEntityCountStateInterface = {
  accounts: [],
  isLoading: false,
  isLoaded: false
};
